import { createContext, type RefObject, useContext } from 'react';

const ScrollingContainerRefContext = createContext<RefObject<Element> | undefined>(undefined);
export const ScrollingContainerRefContextProvider = ScrollingContainerRefContext.Provider;
export const useScrollingContainerRefContextValue = () => useContext(ScrollingContainerRefContext);
